import { Alert, Slide, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import BrandsTabsUnderOperations from "../../../../components/Partners/DataIntegrations/Brands/BrandsTabs";
import { resetBrandsData } from "../../../../features/brandsSlice";
// The reused Run Process wizard (RunBrandData.tsx) dispatches its
// success/failure result into brandConfigurationReportSlice (it wasn't
// forked into brandsSlice — see the Brands independence work). This screen
// reads the same fields, mirroring the working success-banner pattern from
// DataCollectionBrandsScreen.tsx (data_collection/brand_data) — the legacy
// Brand Configuration Report screen itself never actually renders these
// fields anywhere, confirmed by search, so that module has no equivalent UI
// to preserve.
import {
  setIsSuccess,
  setProcessFailure,
} from "../../../../features/brandConfigurationReportSlice";

const BrandsScreen = () => {
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const hasBrandsPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "brands",
    "view_brands",
  );

  const { isSuccess, isProcessFailed, processFailureMessage, resWorkflowName } =
    useSelector((state: any) => state.brandConfigurationReport);

  // Reset on mount so a stale success/failure from a previous visit doesn't
  // show immediately on landing here fresh.
  useEffect(() => {
    dispatch(setIsSuccess(false));
    dispatch(setProcessFailure({ isFailed: false, message: "" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //--Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(resetBrandsData());
    };
  }, [dispatch]);

  const handleClose = () => {
    dispatch(setIsSuccess(false));
    dispatch(setProcessFailure({ isFailed: false, message: "" }));
  };

  const handleProcessLogsNavigation = () => {
    const today = new Date().toISOString().split("T")[0];
    const query = new URLSearchParams({
      start_date: today,
      end_date: today,
      workflow_name: resWorkflowName,
      page: "0",
    });
    window.open(`/data_collection/data_logs?${query.toString()}`, "_blank");
  };

  return (
    <>
      {hasBrandsPermission ? (
        <>
          <Slide direction="left" in={isSuccess} mountOnEnter unmountOnExit timeout={200}>
            <div>
              <Alert
                severity="success"
                onClose={handleClose}
                sx={{
                  mb: 2,
                  border: "1px solid rgba(0, 128, 0, 0.3)",
                  backgroundColor: "rgba(240, 255, 240, 0.9)",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontSize: "17px", fontWeight: "500", marginBottom: "4px" }}
                >
                  The process has been launched successfully!
                </Typography>
                To monitor the workflow results{" "}
                <span
                  onClick={handleProcessLogsNavigation}
                  style={{ textDecoration: "underline", color: "#9C27B0", cursor: "pointer" }}
                >
                  CLICK HERE
                </span>{" "}
                (It may take a few minutes for the logs to appear in the Process Log Table.)
              </Alert>
            </div>
          </Slide>

          <Slide direction="left" in={isProcessFailed} mountOnEnter unmountOnExit timeout={200}>
            <div>
              <Alert
                severity="error"
                onClose={handleClose}
                sx={{
                  mb: 2,
                  border: "1px solid rgba(211, 47, 47, 0.35)",
                  backgroundColor: "rgba(255, 235, 238, 0.9)",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontSize: "17px", fontWeight: "500", marginBottom: "4px" }}
                >
                  The process request had failed
                </Typography>
                {processFailureMessage || "Unknown error occurred"}
              </Alert>
            </div>
          </Slide>

          <BrandsTabsUnderOperations />
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default BrandsScreen;
